import { ThemeOptions } from "@mui/material";

const components: ThemeOptions["components"] = {
  MuiCssBaseline: {
    styleOverrides: (theme) => `
      html, body, #root {
        height: 100%;
        width: 100%;
      }
      pre, code {
        background-color: ${theme.palette.background.code};
        margin: 0;
      }
    `,
  },
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.background.white,
      }),
    },
  },
  MuiAutocomplete: {
    defaultProps: {
      ChipProps: {
        color: "primary",
      },
    },
  },
};

export default components;
